/* SLOVENŠTINA PRO CRM — doplněk sdíleného slovníku UI (klíčem je ČESKÝ TEXT).
 *
 * Vzniklo 18. 10. 2026 (zadání majitele „slovensky, eura, vše ať sedí“):
 * Pipeline klientů, Historie a Rodina ve složce klienta a Servisní radar byly
 * celé česky i u slovenského poradce (nálezy CRM-SK-04/05/06/10).
 *
 * Mechanismus je týž jako `data/prekladyUI.data.js` (do něj se tenhle objekt
 * rozbaluje jako PRVNÍ, takže řádek, který už tam je, má přednost). Vlastní
 * soubor jen proto, aby se v noci nepřepisoval sdílený slovník, ve kterém
 * souběžně pracují jiné týmy.
 *
 * Chybějící jazyk = čeština (dnešní stav). Teď jen `sk`; en/uk/vi doplnit.
 * Zástupné `{n}`, `{jm}`, `{co}` dosazuje volající přes `.replace()`.
 *
 * ⚠️ ŽÁDNÉ ASCII " UVNITŘ TEXTU (rozbíjí JS string, viz CLAUDE.md).
 */
export const PREKLADY_CRM = {
  /* ===== Pipeline klientů (pages/crm/CRMClientsPage.js) ===== */
  "Chyba při načítání dat": { sk: "Chyba pri načítaní údajov" },
  "Nepodařilo se uložit:": { sk: "Nepodarilo sa uložiť:" },
  "klient": { sk: "klient" },
  "klienta": { sk: "klienta" },
  "zapsáno do diáře": { sk: "zapísané do diára" },
  "Fáze posunuta, ale termín se nepodařilo zapsat do diáře. Zkus ho přidat ručně.": { sk: "Fáza posunutá, ale termín sa nepodarilo zapísať do diára. Skús ho pridať ručne." },
  "Klient je bez dalšího kroku — uvidíš ho v ranním brífinku.": { sk: "Klient je bez ďalšieho kroku — uvidíš ho v rannom brífingu." },
  "Podepsáno": { sk: "Podpísané" },
  "Přesunout klienta {jm} do koše? Kdykoli ho lze obnovit v Klienti → Koš.": { sk: "Presunúť klienta {jm} do koša? Kedykoľvek ho možno obnoviť v Klienti → Kôš." },
  "Klient je v koši — obnovíš ho v Klienti → Koš": { sk: "Klient je v koši — obnovíš ho v Klienti → Kôš" },
  "Chyba při mazání": { sk: "Chyba pri mazaní" },
  "Načítám pipeline...": { sk: "Načítavam pipeline..." },
  "Podepsáno (BJ)": { sk: "Podpísané (BJ)" },
  "Podepsané BJ klientů ve fázi Podpis/Servis (pole signed_bj).": { sk: "Podpísané BJ klientov vo fáze Podpis/Servis (pole signed_bj)." },
  "V pipeline (BJ)": { sk: "V pipeline (BJ)" },
  "Odhad BJ klientů ve fázích Analýza→Prezentace (pole estimate_bj). Jiný pohled než 'Aktivní pipeline' na Nástěnce (ta je z modulu Obchody).": { sk: "Odhad BJ klientov vo fázach Analýza→Prezentácia (pole estimate_bj). Iný pohľad ako 'Aktívna pipeline' na Nástenke (tá je z modulu Obchody)." },
  "Blízko uzavření": { sk: "Blízko uzavretia" },
  "Odhad BJ klientů ve fázích Prezentace (P1/P2) — nejblíž podpisu.": { sk: "Odhad BJ klientov vo fázach Prezentácia (P1/P2) — najbližšie k podpisu." },
  "Aktivní": { sk: "Aktívne" },
  "Stagnace 14+": { sk: "Stagnácia 14+" },
  "Podpis tento měsíc": { sk: "Podpis tento mesiac" },
  "Řadit: Poslední aktivita": { sk: "Zoradiť: Posledná aktivita" },
  "Řadit: BJ": { sk: "Zoradiť: BJ" },
  "Řadit: Abeceda": { sk: "Zoradiť: Abeceda" },
  "Všechny měsíce": { sk: "Všetky mesiace" },
  "Hledat…": { sk: "Hľadať…" },
  "V pipeline zatím žádný klient. Přejdi na Zrcadlo volání a nastav Schůzku.": { sk: "V pipeline zatiaľ nie je žiadny klient. Prejdi na Zrkadlo volania a nastav Stretnutie." },
  "Žádný klient neodpovídá filtru.": { sk: "Filtru nezodpovedá žiadny klient." },
  "Pipeline track": { sk: "Priebeh pipeline" },
  "Dní": { sk: "Dní" },
  "Akce": { sk: "Akcie" },
  "dní ve fázi": { sk: "dní vo fáze" },
  "bez telefonu": { sk: "bez telefónu" },
  "Finanční analýza (v2)": { sk: "Finančná analýza (v2)" },
  "Prezentér první schůzky — proč plánovat, proč poradce": { sk: "Prezentér prvého stretnutia — prečo plánovať, prečo poradca" },
  "Fáze zpět": { sk: "Fáza späť" },
  "Další fáze": { sk: "Ďalšia fáza" },
  "Podepsat smlouvu": { sk: "Podpísať zmluvu" },
  "Podepsáno BJ *": { sk: "Podpísané BJ *" },
  "např. 120": { sk: "napr. 120" },
  "Odhad byl:": { sk: "Odhad bol:" },
  "Datum podpisu": { sk: "Dátum podpisu" },
  "Potvrdit podpis": { sk: "Potvrdiť podpis" },

  /* ===== Rodina ve složce klienta (components/crm/HouseholdGraph.js) ===== */
  "Rodinný strom": { sk: "Rodinný strom" },
  "vazba": { sk: "väzba" },
  "vazby": { sk: "väzby" },
  "vazeb": { sk: "väzieb" },
  "Podepsáno celkem": { sk: "Podpísané spolu" },
  "Klikni na": { sk: "Klikni na" },
  "pro propojení s dalším členem rodiny.": { sk: "pre prepojenie s ďalším členom rodiny." },
  "Klik na uzel/kartu = otevři složku člena · hover = přiblížit": { sk: "Klik na uzol/kartu = otvor zložku člena · hover = priblížiť" },
  "Manželka": { sk: "Manželka" },
  "Manžel": { sk: "Manžel" },
  "Dcera": { sk: "Dcéra" },
  "Syn": { sk: "Syn" },
  "Manžel/ka": { sk: "Manžel/ka" },
  "Partner/ka": { sk: "Partner/ka" },
  "Dítě": { sk: "Dieťa" },
  "Rodič": { sk: "Rodič" },
  "Sourozenec": { sk: "Súrodenec" },
  "Hlava rodiny": { sk: "Hlava rodiny" },
  "Vazba": { sk: "Väzba" },

  /* ===== Historie ve složce klienta (components/crm/HistoryTimeline.js) ===== */
  "Tohle se nenačetlo: {co}. Historie níž proto NENÍ úplná.": { sk: "Toto sa nenačítalo: {co}. História nižšie preto NIE JE úplná." },
  "Aktivity": { sk: "Aktivity" },
  "Hlasovky": { sk: "Hlasovky" },
  "Smlouvy": { sk: "Zmluvy" },
  "Úkoly a schůzky": { sk: "Úlohy a stretnutia" },
  "Schůzky": { sk: "Stretnutia" },
  "Telefon": { sk: "Telefón" },
  "E-mail": { sk: "E-mail" },
  "Úkoly": { sk: "Úlohy" },
  "Hlasovka": { sk: "Hlasovka" },
  "Schůzka": { sk: "Stretnutie" },
  "Úkol": { sk: "Úloha" },
  "Aktivita": { sk: "Aktivita" },
  "Telefonát": { sk: "Telefonát" },
  "Dopis": { sk: "List" },
  "Událost": { sk: "Udalosť" },
  "Z hlasovky": { sk: "Z hlasovky" },
  "Od manažera": { sk: "Od manažéra" },
  "Hlasová poznámka": { sk: "Hlasová poznámka" },
  "produkt": { sk: "produkt" },
  "měs.": { sk: "mes." },
  "celkem": { sk: "spolu" },
  "fixace": { sk: "fixácia" },
  "výročí": { sk: "výročie" },
  "(bez názvu)": { sk: "(bez názvu)" },
  "před {n} dny": { sk: "pred {n} dňami" },
  "za {n} dní": { sk: "o {n} dní" },
  "Načítám historii…": { sk: "Načítavam históriu…" },
  "Co nás čeká": { sk: "Čo nás čaká" },
  "Co máme za sebou": { sk: "Čo máme za sebou" },
  "Žádná historie": { sk: "Žiadna história" },
  "Nahrajte hlasovku nebo přidejte úkol — objeví se zde.": { sk: "Nahrajte hlasovku alebo pridajte úlohu — objaví sa tu." },
  "Historii se nepodařilo načíst": { sk: "Históriu sa nepodarilo načítať" },
  "Nejde o prázdnou historii — spojení se serverem selhalo.": { sk: "Nejde o prázdnu históriu — spojenie so serverom zlyhalo." },
  "Realizováno": { sk: "Realizované" },

  /* ===== Servisní radar (pages/ServisRadarPage.js) ===== */
  "Servisní radar": { sk: "Servisný radar" },
  "Komu se ozvat — konce fixací, dožití smluv, výročí a narozeniny. Servis = opakovaný příjem a spokojený klient.": { sk: "Komu sa ozvať — konce fixácií, dožitia zmlúv, výročia a narodeniny. Servis = opakovaný príjem a spokojný klient." },
  "Servis": { sk: "Servis" },
  "Úkol vytvořen → diář": { sk: "Úloha vytvorená → diár" },
  "Nepodařilo se vytvořit úkol": { sk: "Úlohu sa nepodarilo vytvoriť" },
  "Vytvořit úkol": { sk: "Vytvoriť úlohu" },
  "Odbavit": { sk: "Vybaviť" },
  "Načítám radar…": { sk: "Načítavam radar…" },
  "Žádné servisní příležitosti v nejbližších 120 dnech.": { sk: "Žiadne servisné príležitosti v najbližších 120 dňoch." },
  "Jakmile budou smlouvy mít konec fixace/dožití/výročí nebo klienti narozeniny, objeví se tu.": { sk: "Keď budú mať zmluvy koniec fixácie/dožitie/výročie alebo klienti narodeniny, objavia sa tu." },
  "Dnes / po termínu": { sk: "Dnes / po termíne" },
  "Tento týden": { sk: "Tento týždeň" },
  "Tento měsíc": { sk: "Tento mesiac" },
  "Brzy (do 120 dní)": { sk: "Čoskoro (do 120 dní)" },

  /* ===== Cíle & Rocks (pages/crm/CRMGoalsPage.js) — 19. 10. 2026 ===== */
  "Kariéra & měsíční plán": { sk: "Kariéra & mesačný plán" },
  "Pozice určuje koeficient provize (Kč / BJ).": { sk: "Pozícia určuje koeficient provízie (Kč / BJ)." },
  "Moje pozice": { sk: "Moja pozícia" },
  "— vyber pozici —": { sk: "— vyber pozíciu —" },
  "Měsíční plán (BJ)": { sk: "Mesačný plán (BJ)" },
  "např. 200": { sk: "napr. 200" },
  "Tento měsíc podepsáno": { sk: "Tento mesiac podpísané" },
  "Týden": { sk: "Týždeň" },
  "Měsíc": { sk: "Mesiac" },
  "Kvartál (3 měs.)": { sk: "Kvartál (3 mes.)" },
  "90denní Rocks": { sk: "90-dňové Rocks" },
  "Přidat rock": { sk: "Pridať rock" },
  "3–7 čtvrtletních priorit (EOS framework).": { sk: "3–7 štvrťročných priorít (EOS framework)." },
  'Tip: „Uzavřít 15 hypoték do 31.3." / „Získat 3 A-klienty" / „Dokončit modul 3 univerzity".': { sk: "Tip: „Uzavrieť 15 hypoték do 31. 3.“ / „Získať 3 A-klientov“ / „Dokončiť modul 3 univerzity“." },
  "Rock {n} — konkrétní měřitelný cíl": { sk: "Rock {n} — konkrétny merateľný cieľ" },
  "Proč to dělám": { sk: "Prečo to robím" },
  "Napiš si důvody — když přijde těžký den, vracej se sem.": { sk: "Napíš si dôvody — keď príde ťažký deň, vracaj sa sem." },
  "Vlastní byt do 35 let.\nDcera na soukromé ZUŠ.\nTáta v důchodu bez starostí…": { sk: "Vlastný byt do 35 rokov.\nDcéra na súkromnej ZUŠ.\nOtec na dôchodku bez starostí…" },
  "Máte neuložené změny": { sk: "Máte neuložené zmeny" },
  "Máte neuložené změny v cílech. Odejít bez uložení?": { sk: "Máte neuložené zmeny v cieľoch. Odísť bez uloženia?" },
  "Ukládám…": { sk: "Ukladám…" },
  "Uložit cíle": { sk: "Uložiť ciele" },
  "Cíle uloženy": { sk: "Ciele uložené" },
  "Nepodařilo se uložit": { sk: "Nepodarilo sa uložiť" },
  "Maximum 7 rocks — drž se priorit": { sk: "Maximum 7 rocks — drž sa priorít" },
  "Načítám cíle…": { sk: "Načítavam ciele…" },
  "Nepodařilo se načíst cíle.": { sk: "Ciele sa nepodarilo načítať." },
  "Zkusit znovu": { sk: "Skúsiť znova" },
  "Zadejte číslo": { sk: "Zadajte číslo" },
  "Plán nemůže být záporný": { sk: "Plán nemôže byť záporný" },
  "Zadejte celé číslo BJ": { sk: "Zadajte celé číslo BJ" },
  "Příliš velké číslo": { sk: "Príliš veľké číslo" },

  /* ===== Další údaje (components/crm/DalsiUdajeTab.js) — 19. 10. 2026 =====
   * Slovenské NÁZVY polí (IČ DPH, SZČO, ORSR, elektronická schránka) volí
   * ZEMĚ tenanta přímo v komponentě; tady je jen jazyk ostatních popisků. */
  "Identifikace": { sk: "Identifikácia" },
  "Firma": { sk: "Firma" },
  "Právní forma": { sk: "Právna forma" },
  "Zaměstnanců": { sk: "Zamestnancov" },
  "Plátce DPH": { sk: "Platiteľ DPH" },
  "Ano": { sk: "Áno" },
  "Ne": { sk: "Nie" },
  "Platby": { sk: "Platby" },
  "Bank. účet": { sk: "Bank. účet" },
  "Splatnost": { sk: "Splatnosť" },
  "Hotově": { sk: "V hotovosti" },
  "Splatnost 7 dní": { sk: "Splatnosť 7 dní" },
  "Splatnost 14 dní": { sk: "Splatnosť 14 dní" },
  "Splatnost 30 dní": { sk: "Splatnosť 30 dní" },
  "Splatnost 60 dní": { sk: "Splatnosť 60 dní" },
  "Klasifikace": { sk: "Klasifikácia" },
  "Klasifikace 1": { sk: "Klasifikácia 1" },
  "Klasifikace 2": { sk: "Klasifikácia 2" },
  "Klasifikace 3": { sk: "Klasifikácia 3" },
  "zákazník / dodavatel": { sk: "zákazník / dodávateľ" },
  "Komunikace": { sk: "Komunikácia" },
  "Oslovení": { sk: "Oslovenie" },
  "Osobní": { sk: "Osobné" },
  "Narozeniny": { sk: "Narodeniny" },
  "AI vám připomene 7 dní předem (pošle do diáře úkol)": { sk: "AI vám pripomenie 7 dní vopred (pošle do diára úlohu)" },
  "Přílohy": { sk: "Prílohy" },
  "Zařazení": { sk: "Zaradenie" },
  "Skupina": { sk: "Skupina" },
  "Region (kraj)": { sk: "Región (kraj)" },
  "Kraj ze sídla klienta — mění se na záložce Přehled → Sídlo klienta": { sk: "Kraj zo sídla klienta — mení sa na záložke Prehľad → Sídlo klienta" },
  "Kraj z adresy (Přehled → Sídlo klienta). Obchodní region patří do pole Teritorium tamtéž.": { sk: "Kraj z adresy (Prehľad → Sídlo klienta). Obchodný región patrí do poľa Teritórium tamtiež." },
  "Vlastník": { sk: "Vlastník" },
  "Vlastníka kontaktu nelze z této záložky měnit": { sk: "Vlastníka kontaktu nemožno z tejto záložky meniť" },
  "nepřiřazeno": { sk: "nepriradené" },
  "Souhrn údajů": { sk: "Súhrn údajov" },
  "Obrat": { sk: "Obrat" },
  "Uloženo": { sk: "Uložené" },
  "IČO nebo název firmy…": { sk: "IČO alebo názov firmy…" },
  "Použijeme automaticky v šablonách": { sk: "Použijeme automaticky v šablónach" },
};
